class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector('modal-dialog');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
        closeButton.addEventListener('click', this.close.bind(this))
      }
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    // Cible uniquement le nouveau tiroir pour éviter d'ouvrir l'ancien en même temps.
    const superCrossCartDrawer = document.querySelector('.vv-super-cross-cart-drawer');
    if (superCrossCartDrawer) {
      superCrossCartDrawer.classList.add('is-expanded');
    }

    const gradient = document.querySelector('.gradient');
    if (gradient) {
      gradient.classList.add('drawer-open');
    }
    document.body.addEventListener('click', this.onBodyClick);
    this.querySelectorAll('button[data-action="close"]').forEach((closeButton) => {
        closeButton.addEventListener('click', this.close.bind(this))
      }
    );
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.hide();

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const targetElement = document.getElementById(section.id);
      // Use section.source_id if it exists, otherwise default to section.id
      const sourceId = section.source_id || section.id;
      const sourceHTML = parsedState.sections[sourceId];
      if (targetElement && sourceHTML) {
        const newContent = this.getSectionInnerHTML(sourceHTML, section.selector);
        if (newContent) targetElement.innerHTML = newContent;
      }
    });

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      // We tell the script to update the element with id 'vv-scc-drawer-summary'.
      // We also tell it that the source for this update is the full 'vv-super-cross-cart-drawer' section.
      {
        id: 'vv-scc-drawer-summary', // This is the target element ID to update on the page.
        source_id: 'vv-super-cross-cart-drawer', // This is the actual section to fetch from Shopify.
        selector: '#vv-scc-drawer-summary' // This is the element to extract from the fetched HTML.
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // Add a guard to prevent errors if the selector isn't found in the response.
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    if (!element) return null;
    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
